import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "flag--sprite",
  "use": "flag--sprite-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol viewBox=\"0 0 14 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"flag--sprite\">\n<path d=\"M6.87167 2.04171L7.23833 3.87504H12.0417V9.37504H8.96167L8.595 7.54171H1.95833V2.04171H6.87167ZM8.375 0.208374H0.125V15.7917H1.95833V9.37504H7.09167L7.45833 11.2084H13.875V2.04171H8.74167L8.375 0.208374Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol